import Filter from "./features/Filter";
import List from "./features/List";
import {useState} from "react";
import {historySearchParamInit} from "./state";
import {HistorySearchParamType} from "./interface";
import {useReadInventoryHistory} from "./hooks/useReadInventoryHistory";
import moment from "moment/moment";

export default function History() {
    const [searchParam, setSearchParam] = useState<HistorySearchParamType>((() => ({
        ...historySearchParamInit,
        endAt: moment().format("YYYY-MM-DD"),
        startAt: moment().startOf("months").format("YYYY-MM-DD"),
    }))())
    const [selectedHistoryIdx, setSelectedHistoryIdx] = useState<number>(-1)

    const {
        data,
        dataList: history,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        status
    } = useReadInventoryHistory({param: searchParam});

    const fetch = async () => {
        if (hasNextPage) {
            await fetchNextPage()
        }
    }

    return (
        <>
            <Filter searchParam={searchParam}
                    setSearchParam={setSearchParam}
                    setSelectedHistoryIdx={setSelectedHistoryIdx}/>

            <List history={history ?? []}
                  fetch={fetch}
                  selectedHistoryIdx={selectedHistoryIdx}
                  setSelectedHistoryIdx={setSelectedHistoryIdx}/>
        </>
    );
}